import { render, staticRenderFns } from "./lead-form.vue?vue&type=template&id=9033b542&scoped=true"
import script from "./lead-form.vue?vue&type=script&lang=js"
export * from "./lead-form.vue?vue&type=script&lang=js"
import style0 from "./lead-form.vue?vue&type=style&index=0&id=9033b542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9033b542",
  null
  
)

export default component.exports